export const ONBOARDING_PAGE_SLUG = 'onboarding'

export function isOnboardingCmsSlug(slug?: string | null): boolean {
  const cleaned = String(slug ?? '').replace(/^\/+|\/+$/g, '').toLowerCase()
  return cleaned === ONBOARDING_PAGE_SLUG
}

export function omitOnboardingPages<T extends { slug?: string | null }>(pages: T[]): T[] {
  return pages.filter((page) => !isOnboardingCmsSlug(page.slug))
}
